import React from 'react';
import {connect} from "react-redux";
import {injectIntl} from "react-intl";
import PropTypes from "prop-types";

import {setWizardPopupItem, setWizardPopupOpened, updateWizardList} from "../wizardActions";
import {wizardGroupInterface, wizardItemInterface} from "../WizardItem/wizardItemInterface";
import SvgIcons from "../../Icons/SvgIcons";

const WizardNodeVisibleEyeBall = (props) => {

  const {wizardActiveItem, wizardGroup, updateWizardList} = props;

  const updateWizardGroup = () => {
    wizardActiveItem.wizardGroups = wizardActiveItem.wizardGroups.map(wizGroup => {
      if (wizGroup.id === wizardGroup.id) {
        wizardGroup.hideForCustomers = !wizardGroup.hideForCustomers;
      }
      return wizGroup
    })
    updateWizardList(wizardActiveItem);
  }

  return (
    <button className={" wizard-group__visible "
      + (wizardGroup.hideForCustomers ? "wizard-group__visible--off" : "wizard-group__visible--on")}
            onClick={updateWizardGroup}>
      {SvgIcons.eyeBall}
    </button>
  )
};

WizardNodeVisibleEyeBall.propTypes = {
  wizardActiveItem: PropTypes.shape(wizardItemInterface).isRequired,
  wizardGroup: PropTypes.shape(wizardGroupInterface).isRequired,
}

const mapDispatchToProps = {
  updateWizardList,
  setWizardPopupOpened,
  setWizardPopupItem,
};

export default injectIntl(
  connect(null, mapDispatchToProps)(WizardNodeVisibleEyeBall)
)
